import { PencilSquareIcon, PlusCircleIcon } from '@heroicons/react/24/outline';

import { PassengerRead } from 'src/common/external/bambi-api/bambiApi';
import { DefaultFormFieldLayout } from 'src/common/FormField/DefaultFormFieldLayout';
import { Button } from 'src/common/primitives/Button';
import { ExistingPassengerSearch } from 'src/features/add-trip/PassengerInfoFormSection/ExistingPassengerSearch';
import { useIsSelectedTripInThePast } from 'src/features/add-trip/useIsSelectedTripInThePast';
import { useShouldShowRideOrderingPortalFeatures } from 'src/features/rideOrderingPortal/useShouldShowRideOrderingPortalFeatures';

import { useUpdateFormValuesFromPassenger } from './useUpdateFormValuesFromPassenger';

export interface PassengerInfoFormSectionProps {
  selectedPassenger: PassengerRead | null | undefined;
  onPassengerSelected: (passenger: PassengerRead | undefined) => void;
  onPassengerAdd: () => void;
  onPassengerEdit: (passenger: PassengerRead) => void;
}

export function PassengerInfoFormSection({
  selectedPassenger,
  onPassengerSelected,
  onPassengerAdd,
  onPassengerEdit,
}: PassengerInfoFormSectionProps) {
  useUpdateFormValuesFromPassenger({
    passenger: selectedPassenger,
  });
  const isSelectedTripInThePast = useIsSelectedTripInThePast();
  const shouldShowRideOrderingPortalFeatures =
    useShouldShowRideOrderingPortalFeatures();
  return (
    <div>
      <DefaultFormFieldLayout
        label="Passenger *"
        inputProps={{ id: 'passenger' }}
      >
        <div className="flex gap-1">
          <div className="flex grow flex-col">
            <ExistingPassengerSearch
              selectedPassenger={selectedPassenger}
              onPassengerSelected={onPassengerSelected}
              disabled={isSelectedTripInThePast}
            />
          </div>
          {!shouldShowRideOrderingPortalFeatures && (
            <Button
              disabled={!selectedPassenger?.id}
              className="flex gap-2"
              variant="secondary"
              onClick={() => {
                selectedPassenger && onPassengerEdit(selectedPassenger);
              }}
              dataTestId="edit-passenger-button"
            >
              <PencilSquareIcon className="h-5 w-5" /> Edit Selected Passenger
            </Button>
          )}
          <Button
            className="flex gap-2"
            variant="secondary"
            onClick={onPassengerAdd}
            disabled={isSelectedTripInThePast}
            dataTestId="add-passenger-button"
          >
            <PlusCircleIcon className="h-5 w-5" /> Add New Passenger
          </Button>
        </div>
      </DefaultFormFieldLayout>
    </div>
  );
}
